import { Routes } from '@angular/router';
import { NetzzuordnungenPageComponent } from './netzzuordnungen-page/netzzuordnungen-page.component';

export const netzzuordnungenRoutes: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
    },
    {   // lists all Netzzuordnungen
        path: 'list',
        component: NetzzuordnungenPageComponent,
    },
];

